/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useLayout } from '../core'
import StoreBadge from '../../partials/content/StoreBadge'

const Footer: FC = () => {
  const { classes } = useLayout()

  return (
    <>
      <style>{`
        #kt_footer {
          background: var(--bs-body-bg, #fff);
          border-top: 1px solid var(--bs-border-color, #e4e6ef);
        }
        html[data-theme-mode='dark'] #kt_footer {
          background: #1e1e2d;
          border-top: 1px solid #2d2d43;
        }
        .footer-copyright {
          font-size: 13px;
          color: var(--bs-gray-500, #a1a5b7);
        }
        .footer-copyright a {
          font-weight: 600;
          color: var(--bs-gray-700, #5e6278);
          text-decoration: none;
          transition: color .15s;
        }
        .footer-copyright a:hover { color: var(--theme-primary, #009ef7); }
        html[data-theme-mode='dark'] .footer-copyright { color: #565674; }
        html[data-theme-mode='dark'] .footer-copyright a { color: #92929f; }

        .footer-store { display: flex; align-items: center; gap: 10px; list-style: none; margin: 0; padding: 0; }
        .footer-store a { display: inline-block; transition: opacity .15s; }
        .footer-store a:hover { opacity: .85; }
        .footer-store img { height: 38px; width: auto; display: block; border-radius: 10px; }
      `}</style>

      <div className='footer py-6 d-flex flex-lg-column' id='kt_footer'>
        <div className={`${classes.footerContainer} d-flex flex-column flex-md-row align-items-center justify-content-between`}>

          <div className='footer-copyright order-2 order-md-1'>
            <span className='me-1'>{new Date().getFullYear()} &copy;</span>
            <a href='https://www.wisnet.com.tr' rel='noreferrer' target='_blank'>
              Wisnet
            </a>
          </div>

          <ul className='footer-store order-1'>
            <li>
              <StoreBadge
                href='https://apps.apple.com/tr/app/netway-hotspot/id6755966982?l=tr'
                img='/media/store/app_store.png'
                alt="App Store'dan indirin"
                height={38}
              />
            </li>
            <li>
              <StoreBadge
                href='https://play.google.com/store/apps/details?id=com.Wisnet.Netway'
                img='/media/store/google_play.png'
                alt="Google Play'den alın"
                height={38}
                style={{ marginLeft: 10, marginRight: 60 }}
              />
            </li>
          </ul>

        </div>
      </div>
    </>
  )
}

export { Footer }